import { render, staticRenderFns } from "./board-level-automations.vue?vue&type=template&id=05c8d8b8"
import script from "./board-level-automations.vue?vue&type=script&lang=js"
export * from "./board-level-automations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports